<app-block-wrapper [_editable]="_editable" [style]="style">
  <div class="teaser-content-icon-list {{ iconSize }}" [appStoryblok]="_editable">
    <div class="iconed-list">
      <div class="iconed-list-item" *ngFor="let item of items" [appStoryblok]="item._editable">
        <img [src]="item.icon?.filename | storyblokCdn" width="64" height="64" alt="" />
        <div class="iconed-list-item-content" [innerHTML]="item.content | storyblokRichText"></div>
      </div>
    </div>
  </div>
</app-block-wrapper>
